module.exports = __webpack_public_path__ + "img/logo.c712c3e0.png";